// extracted by mini-css-extract-plugin
export default {"signInForm":"SignInForm_signInForm__p1DfV","inputBox":"SignInForm_inputBox__kbuWR","userInput":"SignInForm_userInput__2pHv+","signUpForm":"SignInForm_signUpForm__SAF8R"};